import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { initializeChatbot } from '@sages/chatbot-widget'

import { joinClassNames } from '../../utils/styles'
import styles from './chatbot.module.scss'

function Chatbot() {
    const { t } = useTranslation()

    useEffect(() => {
        const initializeChatbotWidget = async () => {
            initializeChatbot({
                botName: t('chatbot_window_name'),
                apiUrl: process.env.BACKEND_URL,
                webhookPath: '/chat',
                botActionOnInitialization: '/greet',
                initiallyOpen: true,
                containerId: 'chatbot-widget',

                features: {
                    minimize: false,
                },
            })
        }

        initializeChatbotWidget()
    }, [])

    return (
        <div
            id="chatbot-widget"
            className={joinClassNames('container', styles.container)}
        ></div>
    )
}

export default Chatbot
